import React from 'react'
import bgImage from '../assets/images/student.png'
import upcom4 from "../assets/images/afya16.jpeg";
import { EyeIcon, SendIcon, ShareIcon } from 'lucide-react';

export default function AboutSection() {
  return (
    <div className="mx-auto px-6 sm:px-10 md:px-20 mt-16 max-w-7xl">
      <div className="mb-16">
  <div className="flex flex-col sm:flex-row bg-secondary bg-opacity-10 rounded-md justify-between items-center text-center">
    
    <div className="p-6 sm:p-8 flex-1">
      <div className="text-5xl sm:text-6xl text-secondary mb-2 font-bold">+16</div>
      <div className="text-gray-600">Communities Reached</div>
    </div>

    <div className="p-6 sm:p-8 flex-1">
      <div className="text-5xl sm:text-6xl text-secondary mb-2 font-bold">+16</div>
      <div className="text-gray-600">Health Programs</div>
    </div>

    <div className="p-6 sm:p-8 flex-1">
      <div className="text-5xl sm:text-6xl text-secondary mb-2 font-bold">+16</div>
      <div className="text-gray-600">Volunteers Engaged</div>
    </div>

  </div>
</div>

      {/* Section Heading */}
      <div className="bg-secondary bg-opacity-30 w-fit rounded-xl px-4 py-2 mx-auto md:mx-0">
        <p className="text-xl text-center font-medium">About Us</p>
      </div>

      {/* Flex Layout */}
      <div className="mt-6 flex flex-col md:flex-row items-center md:items-start gap-10">
        {/* Left Content */}
        <div className="w-full md:w-6/12 text-gray-600">
          <h2 className="text-3xl sm:text-4xl text-secondary font-bold font-poppins text-center md:text-left">
            Who We Are?
          </h2>

          <p className="mt-6 font-light text-sm sm:text-base leading-relaxed text-center md:text-left">
            Afya Ustawi Foundation (AUF) is a non-governmental organization (NGO)
            registered in Tanzania with registration number 00NGO/R/9495, under
            the Non-Governmental Organizations (NGOs) Act of 2002. It operates
            across the Tanzania Mainland with a mandate to promote holistic
            well-being (ustawi kamili) that extends beyond the absence of
            disease to encompass physical, mental, social, economic, and
            environmental health.
          </p>

          <p className="mt-4 font-light text-sm sm:text-base leading-relaxed text-center md:text-left">
            Inspired by World Health Organisation’s comprehensive definition of
            health and Mwalimu Nyerere’s philosophy on three enemies of the
            nation (poverty, ignorance, and diseases), our foundation strives to
            create a future where people are not only healthier but also
            economically and socially resilient.
          </p>

        
        </div>

        {/* Right Image */}
        <div className="w-full md:w-6/12 flex items-end justify-end">
          <div className="bgg-secondary bg-opacity-80 rounded-lg p-4">
            <img
              src={upcom4}
              alt="student"
              className="w-64 sm:w-80 md:w-[22rem] lg:w-[26rem] rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>

      <div className="bg-gray-50 py-12 px-6 sm:px-12 lg:px-24">
  <div className="max-w-5xl mx-auto text-center mb-10">
    <h2 className="text-3xl sm:text-4xl font-bold text-secondary mb-3">
      Our Mission & Vision
    </h2>
    <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto">
      We are committed to shaping a healthier, empowered future by inspiring individuals and communities to take control of their well-being.
    </p>
  </div>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-8">
    {/* Mission */}
    <div className="group bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
      <div className="flex items-center justify-center w-14 h-14 rounded-full bg-teal-100 text-teal-600 mx-auto mb-4">
        <SendIcon />
      </div>
      <h3 className="text-xl font-semibold text-secondary mb-2">Our Mission</h3>
      <p className="text-gray-600 leading-relaxed">
        Empowering people to gain more control over their health — through knowledge, support, and accessible healthcare solutions that transform lives.
      </p>
    </div>

    {/* Vision */}
    <div className="group bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
      <div className="flex items-center justify-center w-14 h-14 rounded-full bg-indigo-100 text-indigo-600 mx-auto mb-4">
        <EyeIcon size={24} />
      </div>
      <h3 className="text-xl font-semibold text-secondary mb-2">Our Vision</h3>
      <p className="text-gray-600 leading-relaxed">
        To be the leading force in creating a future where every individual is empowered to live healthier, more fulfilling lives — driven by innovation and compassion.
      </p>
    </div>
  </div>
</div>

    </div>
  )
}
